export default "__VITE_PUBLIC_ASSET__c93c4b06__"